import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import validator from "validator";

import Modal from "@/components/Modal";
import { SubmitButton } from "@/components/common";

type Props = {
  comment: string;
  onClose: () => void;
  onSubmit: (text: string) => void;
};

export const CommentEditor = ({ comment, onClose, onSubmit }: Props) => {
  const { t } = useTranslation();

  const [text, setText] = useState(comment);
  const [error, setError] = useState("");

  const handleChangeText = (e) => {
    setText(e.target.value);
  };

  const handleSave = () => {
    // バリデーション
    if (validator.isEmpty(text)) {
      setError(t("comment_unentered"));
      return;
    } else if (100 < text.length) {
      setError(t("comment_too_long"));
      return;
    }
    setError("");

    onSubmit(text);
  };

  return (
    <Modal title={t("comment_edit")} closeHandler={onClose}>
      <div className="modal-body">
        <div className="form-row mb-5">
          <div className="form-group w-370">
            <textarea
              data-test-id="text-comment-editor-comment"
              rows={4}
              className="form-control w-370"
              value={text}
              onChange={handleChangeText}
            />
          </div>
          {error && (
            <div className="form-error w-370">
              <p className="form-error-message w-370">{t(error)}</p>
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <button data-test-id="button-comment-editor-cancel" type="button" className="btn btn-gray" onClick={onClose}>
          {t("cancel")}
        </button>
        <SubmitButton data-test-id="button-comment-editor-save" onClick={handleSave} />
      </div>
    </Modal>
  );
};
